export default "__VITE_ASSET__BI_orAcK__"